import { useOracle } from "@/contexts/OracleContext";
import { Sparkles } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export function OracleToggle() {
  const { isOracleActive, toggleOracle } = useOracle();

  return (
    <div className="fixed bottom-24 right-5 z-50 flex flex-col items-end gap-2">
      <AnimatePresence>
        {isOracleActive && (
          <motion.span 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            className="bg-purple-600 text-white text-[10px] font-black px-3 py-1 rounded-full shadow-lg uppercase tracking-wider"
          >
            Modo Oráculo
          </motion.span>
        )}
      </AnimatePresence>
      <button
        onClick={toggleOracle}
        className={`w-14 h-14 rounded-full flex items-center justify-center transition-all duration-500 shadow-2xl ${
          isOracleActive 
            ? "bg-purple-600 rotate-[360deg] ring-4 ring-purple-200" 
            : "bg-slate-800 opacity-40 hover:opacity-100"
        }`}
      >
        <Sparkles className={`w-7 h-7 ${isOracleActive ? "text-white" : "text-slate-300"}`} />
      </button>
    </div>
  );
}